import { gql } from '@apollo/client';

export const GET_PRODUCT_BRIEFING_BUNDLE = gql`
  query getProductBriefingBundle {
    productBrefingBundle {
      data {
        attributes {
          shortDescription
          section_one {
            content
            title
          }
          section_two {
            content
            title
          }
        }
      }
    }
  }
`;
